const TEACHER_TIER_SELECT = [
  { value: 'COMM', label: 'COMM: FREE' },
  { value: 'TIER_1', label: 'TIER 1: 11/15 USD' },
  { value: 'TIER_2', label: 'TIER 2: 16/23 USD' },
];

module.exports = {
  TEACHER_TIER_SELECT,
};
